import React from 'react';
import { Square, RectangleHorizontal } from 'lucide-react';
import { Button } from '../../../../ui/Button';

interface OrientationSelectorProps {
  onSelect: (orientation: 'portrait' | 'landscape') => void;
  onCancel: () => void;
}

export const OrientationSelector: React.FC<OrientationSelectorProps> = ({
  onSelect,
  onCancel,
}) => {
  const handleModalClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div 
      className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl dark:bg-gray-800" 
      style={{ zIndex: 99999 }}
      onClick={handleModalClick}
    >
      <h3 className="mb-6 text-lg font-medium text-gray-900 dark:text-white">
        Choisissez l'orientation de la fiche
      </h3>

      <div className="grid grid-cols-2 gap-4">
        <button
          onClick={(e) => {
            handleModalClick(e);
            onSelect('portrait');
          }}
          className="flex flex-col items-center gap-4 rounded-lg border-2 border-gray-200 p-6 transition-colors hover:border-primary-500 hover:bg-primary-50 dark:border-gray-700 dark:hover:border-primary-400 dark:hover:bg-primary-900/20"
        >
          <div className="relative h-32 w-24 rounded-lg border-2 border-current p-2 text-gray-400">
            <Square className="h-full w-full" />
          </div>
          <span className="font-medium text-gray-900 dark:text-white">Portrait</span>
          <span className="text-sm text-gray-500 dark:text-gray-400">Format A4 vertical</span>
        </button>

        <button
          onClick={(e) => {
            handleModalClick(e);
            onSelect('landscape');
          }}
          className="flex flex-col items-center gap-4 rounded-lg border-2 border-gray-200 p-6 transition-colors hover:border-primary-500 hover:bg-primary-50 dark:border-gray-700 dark:hover:border-primary-400 dark:hover:bg-primary-900/20"
        >
          <div className="relative h-24 w-32 rounded-lg border-2 border-current p-2 text-gray-400">
            <RectangleHorizontal className="h-full w-full" />
          </div>
          <span className="font-medium text-gray-900 dark:text-white">Paysage</span>
          <span className="text-sm text-gray-500 dark:text-gray-400">Format A4 horizontal</span>
        </button>
      </div>

      <div className="mt-6 flex justify-end gap-4" onClick={handleModalClick}>
        <Button 
          variant="secondary" 
          onClick={(e) => {
            handleModalClick(e);
            onCancel();
          }}
        >
          Annuler
        </Button>
      </div>
    </div>
  );
};